
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19.333 12.667v18.666H14V12.667h5.333zm10.667 0v18.666h-5.333V12.667H30z","fill-rule":"evenodd"}})])
      }
    
      }
    